const chip = {
  label1: 'nenhum selecionado',
  label2: 'selecionado(s)',
  Typography: 'selecionar todos'
}

export default chip;